import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { testimonials } from '../data/mockData';
import { TestimonialCard } from './testimonials/TestimonialCard';
import { useCarousel } from '../hooks/useCarousel';

const navBtnStyle = {
  padding: '0.75rem',
  borderRadius: '50%',
  background: 'var(--white)',
  border: '2px solid var(--gray-200)',
  cursor: 'pointer',
  transition: 'var(--transition-base)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const CarouselNav = ({ index, total, onPrev, onNext, onGoTo }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '2rem', gap: '1rem' }}>
    <button onClick={onPrev} style={navBtnStyle} aria-label="Previous testimonial">
      <ChevronLeft size={20} />
    </button>

    <div style={{ display: 'flex', gap: '0.5rem' }}>
      {testimonials.map((t, i) => (
        <button
          key={t.id}
          onClick={() => onGoTo(i)}
          aria-label={`Go to testimonial ${i + 1}`}
          style={{
            width: '0.75rem',
            height: '0.75rem',
            borderRadius: '50%',
            border: 'none',
            background: i === index ? 'var(--accent-gold-dark)' : 'var(--gray-300)',
            cursor: 'pointer',
            transition: 'var(--transition-base)'
          }}
        />
      ))}
    </div>

    <button onClick={onNext} style={navBtnStyle} aria-label="Next testimonial">
      <ChevronRight size={20} />
    </button>
  </div>
);

export const TestimonialsSection = () => {
  const { index, next, prev, goTo } = useCarousel(testimonials.length);

  return (
    <section id="testimonials" className="section" data-testid="testimonials-section">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <h2 className="heading-1">What Our Clients Say</h2>
          <p
            className="body-large"
            style={{ maxWidth: '800px', margin: '0 auto', color: 'var(--text-secondary)' }}
          >
            Don't just take our word for it. Here's what our satisfied clients have to say about
            their experience with SS Consultancy.
          </p>
        </div>

        {/* Desktop grid */}
        <div className="testimonials-grid" style={{ display: 'grid' }}>
          {testimonials.map((t) => (
            <TestimonialCard key={t.id} testimonial={t} />
          ))}
        </div>

        {/* Mobile carousel */}
        <div style={{ display: 'none' }} className="mobile-carousel">
          <div style={{ position: 'relative', overflow: 'hidden', borderRadius: '1rem' }}>
            <div
              style={{
                display: 'flex',
                transition: 'transform 0.5s ease-in-out',
                transform: `translateX(-${index * 100}%)`
              }}
            >
              {testimonials.map((t) => (
                <div key={t.id} style={{ width: '100%', flexShrink: 0, padding: '0 1rem' }}>
                  <TestimonialCard testimonial={t} centerLayout />
                </div>
              ))}
            </div>
          </div>

          <CarouselNav
            index={index}
            total={testimonials.length}
            onPrev={prev}
            onNext={next}
            onGoTo={goTo}
          />
        </div>
      </div>
    </section>
  );
};
